import React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { ChatbotDesktop } from './components/ChatbotDesktop';
import { ChatbotMobile } from './components/ChatbotMobile';
import { VetChatForm } from './components/VetChatForm';
import vetAssistantImg from '../../../../assets/images/vet-profiles/vet-assistant.png';
import { useVetChatbot } from '../../../../hooks/useVetChatbot';
import { useSplit } from '../../../../hooks/useSplit';
import { FeatureFlags } from '../../../../constants/feature-flags';
import { HtmlIds } from '../../../../constants/html-ids';
import { SplitTreatments } from '../../../../constants';
import { Box } from '../../../../wag-react/next-components/box';
import { theme } from '../../../../wag-react/themes/base-theme';
import { VetChatbotProps } from '../../../../wag-react/components/chat-bot';
const chatBotTheme = {
  botBubbleColor: '#EDEDED',
  botFontColor: '#474747',
  headerBgColor: theme.colors.gulfBlue,
  headerFontColor: theme.colors.white,
  userBubbleColor: '#353F5B',
  // TODO: Change to "gulfBlue" when wag-react published theme has it
  userFontColor: theme.colors.white,
  footerbgColor: theme.colors.white
};
export const HealthVetChatWidget = () => {
  const {
    steps
  } = useVetChatbot();
  const {
    splitTreatment
  } = useSplit(FeatureFlags.VetChatLandingTreatment);
  return <ThemeProvider theme={chatBotTheme} data-sentry-element="ThemeProvider" data-sentry-component="HealthVetChatWidget" data-sentry-source-file="index.tsx">
      <ChatBotGlobalStyle data-sentry-element="ChatBotGlobalStyle" data-sentry-source-file="index.tsx" />
      <Box id={HtmlIds.VET_CHAT_WIDGET} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Box position={['static', null, 'fixed']} width={[1, null, '30%']} ml={[0, null, '36px']} height={['350px', 'auto']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Box display={['none', null, 'block']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            {(splitTreatment === SplitTreatments.Control || splitTreatment === SplitTreatments.Off) && <ChatbotDesktop vetAssistantImg={vetAssistantImg} steps={steps as unknown as VetChatbotProps['steps']} />}

            {splitTreatment === SplitTreatments.On && <VetChatForm />}
          </Box>
          <Box display={['block', null, 'none']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <ChatbotMobile isOpen={false} steps={steps as unknown as VetChatbotProps['steps']} data-sentry-element="ChatbotMobile" data-sentry-source-file="index.tsx" />

            {splitTreatment === SplitTreatments.On && <VetChatForm />}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>;
};
const ChatBotGlobalStyle = createGlobalStyle`
  .rsc-input::placeholder {
    color: ${theme.colors.wagGray};
  }
  .rsc-content, .rsc-footer {
    background-color: ${theme.colors.white};
  }
  .rsc-content {
    margin-top: unset;
  }
`;